import React, { useState } from 'react';
import { Alert, Button, Collapse } from 'react-bootstrap';
import { formatDeadlineDay } from '@/shared/utils/deadline';

const BODY_ID = 'adp-revision-note-body';

/**
 * The coordinator's note on a returned request, shown on every step of the
 * revision. Open by default; the heading folds it away to save room on a
 * phone.
 */
export default function RevisionNote({ notes, requestedBy, requestedAt }) {
    const [open, setOpen] = useState(true);
    if (!notes) return null;

    const who = requestedBy?.name || 'A coordinator';
    const when = requestedAt ? ` on ${formatDeadlineDay(requestedAt)}` : '';

    return (
        <Alert variant="warning" id="adp-revision-note" role="note">
            <Button
                variant="link"
                className="p-0 fw-bold text-start text-decoration-none text-reset"
                aria-expanded={open}
                aria-controls={BODY_ID}
                onClick={() => setOpen((prev) => !prev)}
            >
                Revision requested by {who}
                {when}
            </Button>
            <Collapse in={open}>
                <div id={BODY_ID}>
                    <p className="mb-0 mt-2 text-pre-line text-break">
                        {notes}
                    </p>
                </div>
            </Collapse>
        </Alert>
    );
}
